import { UseQueryOptions } from '@tanstack/react-query';
import { SortDirection } from 'components/table/Table.types';
import useAppQuery from 'hooks/useAppQuery';
import { PromoCodeStatus, GetPromoCodesResponse } from 'models/PromoCode';
import API from 'services/API';

export const PROMO_CODES_BASE_QUERY_KEY = 'promo-codes';

type ReactQueryOptions = Omit<
  UseQueryOptions<GetPromoCodesResponse>,
  'queryKey' | 'queryFn'
>;

export enum FetchPromoCodesSortBy {
  SORT_BY_CODE = 'SORT_BY_CODE',
  SORT_BY_STATUS = 'SORT_BY_STATUS',
  SORT_BY_TYPE = 'SORT_BY_TYPE',
  SORT_BY_VALUE = 'SORT_BY_VALUE',
  SORT_BY_CURRENCY = 'SORT_BY_CURRENCY',
  SORT_BY_SINGLE_USAGE = 'SORT_BY_SINGLE_USAGE',
  SORT_BY_VALID_FROM_DATE_TIME = 'SORT_BY_VALID_FROM_DATE_TIME',
  SORT_BY_VALID_TO_DATE_TIME = 'SORT_BY_VALID_TO_DATE_TIME',
  SORT_BY_EXPIRATION_DATE_TIME = 'SORT_BY_EXPIRATION_DATE_TIME',
  SORT_BY_CREATED_DATE = 'SORT_BY_CREATED_DATE',
}

export type FetchPromoCodesParams = {
  statuses?: PromoCodeStatus[];
  from?: string;
  to?: string;
  sort?: FetchPromoCodesSortBy;
  sortDirection?: SortDirection;
  _cursor?: string;
  _limit?: number;
};

type useFetchPromoCodesArgs = {
  params: FetchPromoCodesParams;
} & ReactQueryOptions;

export const fetchPromoCodes = async (params: FetchPromoCodesParams) => {
  const response = await API.get<GetPromoCodesResponse>(
    '/api/v3.2/promo-codes',
    {
      params: { ...params, statuses: params.statuses?.join(',') },
    },
  );
  return response.data;
};

export const useFetchPromoCodes = ({
  params,
  enabled = true,
  ...options
}: useFetchPromoCodesArgs) => {
  return useAppQuery<GetPromoCodesResponse>({
    queryKey: [PROMO_CODES_BASE_QUERY_KEY, params],
    queryFn: () => fetchPromoCodes(params),
    enabled,
    ...(options ?? {}),
  });
};
